import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { HardCopyActivityAuditTrialDetails } from '../models/hardcopyactivity-audit-trial-details';
import { PanelList } from '../../shared/models/panel-list';
import { FilterMenu } from '../../shared/models/filter-menu';
import { SortMenu } from '../../shared/models/sort-menu';
import { CommonService } from '../../shared/services/common.service';

@Component({
  selector: 'app-hardcopyactivity-audit-summary',
  templateUrl: './hardcopyactivity-audit-summary.component.html',
  styleUrls: ['./hardcopyactivity-audit-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HardcopyactivityAuditSummaryComponent {
  @Input() auditSummaryDetails!: HardCopyActivityAuditTrialDetails[];
  @Output() attributeDetailsOfTransaction = new EventEmitter();
  isHardCopyActivityAuditSummaryLoaded: boolean = true;
  hardCopyActivityAuditSummaryInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableToggling: false,
    enableSelection: false,
    enablePanelCardClick: true,
    enablePanelHighLight:true
  };

  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.bindHardCopyActivitytAuditSummary();
  }

  bindHardCopyActivitytAuditSummary = () => {
    this.hardCopyActivityAuditSummaryInput.lists = this.auditSummaryDetails;
    this.hardCopyActivityAuditSummaryInput.filters = this.getFiltersForHardCopyctivityAuditList();
    this.hardCopyActivityAuditSummaryInput.sort = this.getSortFieldsForHardCopyActivityAuditList();
    this.hardCopyActivityAuditSummaryInput.clearSelection = true;
    this.isHardCopyActivityAuditSummaryLoaded = !this.commonService.IsListEmpty(this.auditSummaryDetails);
    this.hardCopyActivityAuditSummaryInput = { ...this.hardCopyActivityAuditSummaryInput };
  }
  private getFiltersForHardCopyctivityAuditList = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'User',
        filterFieldName: 'user',
      },
      {
        filterDisplayName: 'Action',
        filterFieldName: 'action',
      }
    );
    return filters;
  };
  private getSortFieldsForHardCopyActivityAuditList = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'User',
        sortFieldName: 'user',
      },
      {
        sortFieldDisplayName: 'Action',
        sortFieldName: 'action',
      }
    );
    return sortMenu;
  };
  showAuditAttributeDetails = (data: any) => {
    this.attributeDetailsOfTransaction.emit(data);;
  }
}
